import type { JsonApiResponseSingle } from 'json-api-normalizer';

import api from 'api/apiInstance';
import { mapFormData } from 'helpers/formData';

export interface AdviserUpdateAsPdPatchOptions {
  canRemoveClients: boolean;
}

export function adviserUpdateAsPdApi(path: string) {
  return {
    path,
    PATCH: (params: AdviserUpdateAsPdPatchOptions) =>
      api.patch<JsonApiResponseSingle>(path, {
        data: {
          attributes: mapFormData(params),
        },
      }),
  };
}
